'use client';

export const Upload = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M14.9529 7.02583L11.2629 10.7158C11.0601 10.9225 10.8165 11.0224 10.532 11.0154C10.2479 11.0088 9.99356 10.9004 9.76911 10.6904C9.5655 10.4718 9.46383 10.2211 9.46411 9.93833C9.46467 9.65556 9.56994 9.40903 9.77994 9.19875L15.0883 3.89042C15.2247 3.75431 15.3679 3.65514 15.5179 3.59292C15.6681 3.53097 15.8305 3.5 16.0049 3.5C16.1797 3.5 16.3404 3.53097 16.487 3.59292C16.6337 3.65514 16.7751 3.75417 16.9112 3.89L22.237 9.21583C22.4437 9.4225 22.5483 9.66556 22.5508 9.945C22.5533 10.2247 22.4523 10.4732 22.2479 10.6904C22.0234 10.9004 21.7698 11.0068 21.487 11.0096C21.2043 11.0124 20.9543 10.9051 20.737 10.6879L17.047 7.02583V20.8867C17.047 21.1839 16.9463 21.4328 16.7449 21.6333C16.5436 21.8336 16.2936 21.9338 15.9949 21.9338C15.6963 21.9338 15.448 21.8336 15.2499 21.6333C15.0519 21.4328 14.9529 21.1839 14.9529 20.8867V7.02583Z"
				fill="currentColor"
			/>
			<path
				d="M4.26625 27.8279C4.77708 28.3388 5.39069 28.5942 6.10708 28.5942H25.8929C26.6093 28.5942 27.2229 28.3388 27.7337 27.8279C28.2446 27.3171 28.5 26.7035 28.5 25.9871V22.0471C28.5 21.7499 28.401 21.5011 28.2029 21.3008C28.0049 21.1003 27.7565 21 27.4579 21C27.1593 21 26.9093 21.1003 26.7079 21.3008C26.5065 21.5011 26.4058 21.7499 26.4058 22.0471V25.9871C26.4058 26.1154 26.3525 26.2331 26.2458 26.34C26.1389 26.4467 26.0213 26.5 25.8929 26.5H6.10708C5.97875 26.5 5.86111 26.4467 5.75417 26.34C5.6475 26.2331 5.59417 26.1154 5.59417 25.9871V22.0471C5.59417 21.7499 5.49514 21.5011 5.29708 21.3008C5.09903 21.1003 4.85069 21 4.55208 21C4.25347 21 4.00347 21.1003 3.80208 21.3008C3.60069 21.5011 3.5 21.7499 3.5 22.0471V25.9871C3.5 26.7035 3.75542 27.3171 4.26625 27.8279Z"
				fill="currentColor"
			/>
		</svg>
	);
};
